namespace $.$$ {
	$mol_style_define( $shm_hitalama_components_tests_detail, {
		width: '30rem', maxWidth: '100%', flex: { grow: 1, shrink: 0, basis: '30rem' },
		Report: { minWidth: 0, maxWidth: '100%', overflowWrap: 'anywhere' },
		'[test_status]': {
			success: { Result_status: { color: $shm_theme.success } },
			error: { Result_status: { color: $shm_theme.error } },
			active: { Result_status: { color: $shm_theme.active } },
		},
	})
}
